import { render, staticRenderFns } from "./OtpLoginPage.vue?vue&type=template&id=2e9826cc&scoped=true"
import script from "./OtpLoginPage.vue?vue&type=script&lang=ts"
export * from "./OtpLoginPage.vue?vue&type=script&lang=ts"
import style0 from "./OtpLoginPage.vue?vue&type=style&index=0&id=2e9826cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9826cc",
  null
  
)

export default component.exports